import { render, staticRenderFns } from "./CampusEditor.vue?vue&type=template&id=855058b0&"
import script from "./CampusEditor.vue?vue&type=script&lang=ts&"
export * from "./CampusEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports